// import '@babel/polyfill';

import './common/styles/app.less';
import 'react-datetime/css/react-datetime.css';

import React from 'react';
import ReactDOM from 'react-dom';
import reducer from './redux/modules/reducer';
import createStore from './redux/create';
import ApiClient from './helpers/ApiClient';
import getProvider from './provider';
import { saveUtmParams } from './utils/utm';
import tracking from './tracking';

tracking(global.__bncfg);

const stateElement = document.getElementById('state');
const ttl =
  (stateElement &&
    (stateElement.dataset
      ? stateElement.dataset.ttl
      : stateElement.getAttribute('data-ttl'))) ||
  null;
const stateExpired = !ttl || Date.now() > ttl;

const reduxState = stateElement.textContent || null; // stateExpired ? stateElement.textContent : {};

const store = createStore({
  reducer,
  client: new ApiClient(),
  data: reduxState
});

const provider = getProvider({
  store,
  reload: stateExpired
});

const dest = document.getElementById('content');

if (__DEV__) {
  global.React = React; // enable debugger
}

saveUtmParams();

ReactDOM.hydrate(provider, dest);
